/**
 * t() com parâmetros que nunca deixa "{n}" na tela.
 *
 * Na primeira vez que uma chave nova é usada, o handleMissingTranslation do main.ts devolve a
 * própria chave, sem interpolar, e só registra a mensagem para a PRÓXIMA chamada. Um texto
 * reativo se conserta no render seguinte; um texto montado uma vez (a mensagem de um confirm, um
 * toast) fica com o marcador cru. Aqui os marcadores que sobraram no texto são preenchidos com os
 * mesmos parâmetros. Um marcador sem parâmetro fica como está.
 */
export type TFn = (chave: string, parametros?: Record<string, unknown>) => string

export function tComParametros(t: TFn, chave: string, parametros: Record<string, string | number>): string {
  const texto = t(chave, parametros)
  return texto.replace(/\{(\w+)\}/g, (marcador, nome: string) =>
    Object.prototype.hasOwnProperty.call(parametros, nome) ? String(parametros[nome]) : marcador,
  )
}
